(() => {
  const SECTION_SELECTOR = '.oddit-section-blog-listing';

  function initSection(section) {
    const controller = new AbortController();
    section._odditAbortController = controller;
    const signal = controller.signal;

    const filterNav = section.querySelector('.oddit-section-blog-listing__filter-nav');
    if (filterNav) {
      const bgEl = filterNav.querySelector('.oddit-section-blog-listing__filter-pill-bg');

      filterNav.addEventListener('click', (e) => {
        const pill = e.target.closest('.oddit-section-blog-listing__filter-pill');
        if (!pill) return;

        const allPills = filterNav.querySelectorAll('.oddit-section-blog-listing__filter-pill');
        for (const p of allPills) {
          p.classList.remove('oddit-section-blog-listing__filter-pill--active');
          p.setAttribute('aria-pressed', 'false');
        }

        pill.classList.add('oddit-section-blog-listing__filter-pill--active');
        pill.setAttribute('aria-pressed', 'true');

        /* Move the decorative background SVG into the newly-active pill */
        if (bgEl) {
          pill.insertBefore(bgEl, pill.firstChild);
        }

        /* Filter articles by tag */
        const selectedTag = pill.dataset.tag;
        const cards = section.querySelectorAll('.oddit-section-blog-listing__card');
        const rows = section.querySelectorAll('.oddit-section-blog-listing__row');

        cards.forEach((card) => {
          if (!selectedTag) {
            card.style.display = '';
            return;
          }
          const cardTags = (card.dataset.tags || '').split(',').map((t) => t.trim()).filter(Boolean);
          card.style.display = cardTags.includes(selectedTag) ? '' : 'none';
        });

        /* Hide empty rows */
        rows.forEach((row) => {
          const visibleCards = row.querySelectorAll('.oddit-section-blog-listing__card:not([style*="display: none"])');
          row.style.display = visibleCards.length === 0 ? 'none' : '';
        });
      }, { signal });
    }

    const loadMoreBtn = section.querySelector('.oddit-section-blog-listing__load-more');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', async () => {
        const nextUrl = loadMoreBtn.dataset.nextUrl;
        if (!nextUrl) return;

        loadMoreBtn.disabled = true;

        try {
          const res = await fetch(nextUrl);
          if (!res.ok) throw new Error('Network response was not ok');
          const html = await res.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('.oddit-section-blog-listing__grid');
          const currentGrid = section.querySelector('.oddit-section-blog-listing__grid');

          if (newGrid && currentGrid) {
            const newRows = newGrid.querySelectorAll('.oddit-section-blog-listing__row');
            newRows.forEach((row) => currentGrid.appendChild(row));
          }

          const newLoadMore = doc.querySelector('.oddit-section-blog-listing__load-more');
          if (newLoadMore) {
            loadMoreBtn.dataset.nextUrl = newLoadMore.dataset.nextUrl;
            loadMoreBtn.disabled = false;
          } else {
            loadMoreBtn.remove();
          }
        } catch (err) {
          console.error('Load more failed:', err);
          loadMoreBtn.disabled = false;
        }
      }, { signal });
    }
  }

  function destroySection(section) {
    if (section._odditAbortController) {
      section._odditAbortController.abort();
      delete section._odditAbortController;
    }
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();